<template>
  <div id="test_app">
      <h1>老板你试试可以不</h1>
      <button @click="openExchange">打开交易所</button>
      <!-- <button @click="openTrade">打开交易对</button> -->
  </div>
</template>

<script>
export default {
    name: 'TestApp',
    methods: {
        openExchange() {
            this.$setupWebViewJavascriptBridge(function(bridge) {
				bridge.callHandler('handleOpen', {data: {exchange: 'binance', cp: 'btc-usdt', isBonus: true}});
            }); 
        },
        openTrade() {
            this.$setupWebViewJavascriptBridge(function(bridge) {
				bridge.callHandler('handleOpen', '');
            });
        },
    }
}
</script>

<style>

</style>